export const queryKeys = {
  // Consolidate all your query keys here
  auth: {
    testApi: ["auth", "test-api"] as const,
  },
  registrations: {
    detail: (id?: string | number | undefined | null) =>
      id ? ["registrations", "detail", String(id)] : ["registrations", "detail"],
    list: (params: { page: number; limit: number; search?: string }) =>
      ["registrations", "list", params] as const,
    stats: ["registrations", "stats"] as const,
  },
  user: {
    stats: ["user", "stats"] as const,
    banks: ["user", "banks"] as const,
  },
  admin: {
    stats: ["admin", "stats"] as const,
  },
  dailyReports: {
    list: ["daily-reports", "list"] as const,
    detail: (id: number) => ["daily-reports", "detail", id] as const,
  },
  printCoupons: {
    detail: (propertyPurchaseId: string | number) =>
      ["print-coupons", "detail", String(propertyPurchaseId)] as const,
  },
} as const;
